import { getApiUrlV2 } from "../helper/renderApiDomain";
import { get, patch } from "../helper/request";

export const getContest = async ({
  status = "opening",
  page = 1,
  limit = 9,
} = {}) => {
  return get(
    `${getApiUrlV2()}contest?status=${status}&page=${page}&limit=${limit}`
  );
};

export const getContestByID = async ({ id }) => {
  return get(`${getApiUrlV2()}contest/` + id);
};

export const getContestDetail = async ({ id }) => {
  return get(`${getApiUrlV2()}contest/` + id + "/language");
};

export const getContestWinner = async ({ id }) => {
  return get(`${getApiUrlV2()}contest/` + id + "/winner/general");
};

export const getContestLuckyDraw = async ({ id, page = 1, limit = 9 } = {}) => {
  return get(
    `${getApiUrlV2()}contest/${id}/winner/lucky?page=${page}&limit=${limit}`
  );
};

export const getContestRanking = async ({ id, page = 1, limit = 25 } = {}) => {
  return get(
    `${getApiUrlV2()}contest/${id}/participant/return?page=${page}&limit=${limit}`
  );
};

export const getContestMe = async ({ id }) => {
  return get(`${getApiUrlV2()}contest/${id}/participant/me`);
};

export const getContestChartReturn = async ({ id }) => {
  return get(`${getApiUrlV2()}contest/${id}/chart`);
};

export const getContestPieChart = async ({ id }) => {
  return get(`${getApiUrlV2()}contest/${id}/top-trade`);
};

export const contestOpenAcount = async ({ id }) => {
  return get(`${getApiUrlV2()}user/account/trade-real/contest/add`);
};

export const getDataBannerContest = async () => {
  return get(`${getApiUrlV2()}contest/status/?keyName=trade_and_win`);
};

export const changeContestName = async ({ id, name }) => {
  return patch(`${getApiUrlV2()}contest/participant/${id}/username`, {
    username: name,
  });
};
